/**
 * Convert number into specific locale number format.
 *
 * @param {number} number Number to convert.
 * @param {string} locale Locale code
 *
 * @returns {*}
 */
export default function numberToLocaleNumber(number, locale = navigator.language) {
    try {
        return number.toLocaleString(locale);
    } catch (err) {
        return number;
    }
}
